
<template>
  <el-container>
    <div v-if="this.$route.path !== '/login' && this.$route.path !== '/timeOut'">
      <Header></Header>
    </div>
    <el-main class="container" >
      <keep-alive >
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </el-main>
    <!-- <el-footer>
      <Footer></Footer>
    </el-footer> -->
  </el-container>
</template>
<script>
import Header from './Header.vue'

export default {
  name: 'Layout',
  data() {
    return {}
  },
  components: {
    Header
  },
  created(){
    this.onload();
  },
  methods: {
    onload(){
      console.log("$route-------------->", this.$route)
    }
  }
}
</script>

<style>
.layout {
  width: 100%;
}
.el-main {
  padding: 0 !important;
}
</style>


